import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-calisthenics',
	options: {
		userTags: ['calisthenics'],
	},
	landing: {
		ids: ['loader-calisthenics-f', 'age-calisthenics-f'],
		route: {
			path: '/activity-calisthenics-f',
			name: 'female-activity-calisthenics-funnel',
		},
	},
	funnel: {
		id: 'ob-female-activity-calisthenics',
		route: {
			path: '/activity-calisthenics-f/ob/:page*',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'female-activity-calisthenics-onboarding',
		},
		// @ts-expect-error - Legacy: slug не совпадает с appArea, будет исправлено позже
		slug: 'female-activity-calisthenics',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-calisthenics-f',
	},
	upsell: {
		routeNames: ['upsell-calisthenics-f'],
	},
	upgrade: {
		routeName: null,
	},
}

export default appAreaConfig
